// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, MenuItem, Paper, Select, TextField, Typography } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../../common/loader/Loader'
import { EXCEL_MIME_TYPE } from '../../../../common/utils'
import { i18n } from '../../../index'
import { uploadHesburgerEfficiencies } from '../../../weeklyInfo/weeklyInfoQueries'
import ChainSettingsTable from './ChainSettingsTable'
import NoteDialog from './NoteDialog'
import ChainCheckQuestionSection from '../../checkQuestion/ChainCheckQuestionSection'
import css from './chainSettings.css'
import { fetchChainSettings } from './chainSettingsQueries'

class ChainSettings extends React.PureComponent<Props, State> {
  state = {
    isDialogOpen: false,
    heseUploadResult: [],
    file: '',
    week: 1,
    year: '',
    month: 1,
    monthFile: '',
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      selectedNote: null,
    })
  }
  setDefaultTime = () => {
    const currentYear = new Date().getFullYear()
    const weekNumber = moment().format('w')
    const week = weekNumber === 52 ? 1 : parseInt(weekNumber, 10) + 1
    const year = week === 1 ? currentYear + 1 : currentYear
    const month = moment().format('M')
    this.setState({
      week,
      year,
      month,
    })
  }
  fileHandler = (event) => {
    const [file] = event.target.files
    this.setState({
      file,
    })
  }
  monthFileHandler = (event) => {
    const [monthFile] = event.target.files
    this.setState({
      monthFile,
    })
  }
  upload = async (onMutate) => {
    const { file, week, year } = this.state

    if (file) {
      const formattedFile = await this.fileToBase64(file)

      try {
        const result = await onMutate({
          variables: {
            file: formattedFile,
            date: `${year}W${week.toString().padStart(2, '0')}`,
          },
        })
        this.setState({
          heseUploadResult: result.data.uploadHesburgerEfficiencies,
        })
        this.openDialog()
      } catch (e) {
        this.setState({
          heseUploadResult: 'error',
        })
        this.openDialog()
      }
    }
  }

  uploadMonthly = async (onMutate) => {
    const { monthFile, month, year } = this.state
    if (monthFile) {
      const formattedMonthFile = await this.fileToBase64(monthFile)

      try {
        const result = await onMutate({
          variables: {
            file: formattedMonthFile,
            date: `${year}-${month.toString().padStart(2, '0')}`,
          },
        })
        this.setState({
          heseUploadResult: result.data.uploadHesburgerEfficiencies,
        })
        this.openDialog()
      } catch (e) {
        this.setState({
          heseUploadResult: 'error',
        })
        this.openDialog()
      }
    }
  }

  fileToBase64 = (file: File) => {
    return new Promise((resolve) => {
      const reader = new FileReader()

      reader.onload = (event) => {
        if (event.target) {
          resolve(event.target.result)
        }
      }

      // Convert data to base64
      reader.readAsDataURL(file)
    })
  }
  handleWeek = (event) => {
    this.setState({
      week: event.target.value,
    })
  }

  handleMonth = (event) => {
    this.setState({
      month: event.target.value,
    })
  }
  handleYear = (event) => {
    this.setState({
      year: parseInt(event.target.value, 10),
    })
  }

  componentDidMount() {
    this.setDefaultTime()
  }

  render() {
    const { file, week, year, month, monthFile } = this.state
    const menuItemsWeek = []

    for (let i = 1; i < 53; i++) {
      menuItemsWeek.push(
        <MenuItem key={i} value={i}>
          {i}
        </MenuItem>,
      )
    }

    const menuItemsMonth = _.range(1, 13).map((monthNumber) => (
      <MenuItem key={monthNumber} value={monthNumber}>
        {monthNumber}
      </MenuItem>
    ))

    return (
      <div>
        <div className={css.top}>
          <Typography variant='h6'>{i18n.t('admin.chainSettings.pageTitle')}</Typography>
        </div>
        <Paper className={css.settingsTable}>
          <Query query={fetchChainSettings}>
            {({ loading, error, data }) => (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <ChainSettingsTable data={data.chainSettings} />
              </Loader>
            )}
          </Query>
        </Paper>
        <Paper>
          <div className={css.paperWrapper}>
            <div className={css.top}>
              <Typography variant='h6'>{i18n.t('admin.chainSettings.heseUpload')}</Typography>
            </div>
            <p>{i18n.t('admin.chainSettings.heseUploadExplanation')}</p>
            <UploadWeeklyHesburgerEfficiencies
              menuItems={menuItemsWeek}
              file={file}
              week={week}
              year={year}
              handleYear={this.handleYear}
              handleWeek={this.handleWeek}
              fileHandler={this.fileHandler}
              upload={this.upload}
            />
            <UploadMonthlyHesburgerEfficiencies
              menuItems={menuItemsMonth}
              file={monthFile}
              month={month}
              year={year}
              handleYear={this.handleYear}
              handleMonth={this.handleMonth}
              fileHandler={this.monthFileHandler}
              upload={this.uploadMonthly}
            />
          </div>
        </Paper>
        <ChainCheckQuestionSection />
        <NoteDialog result={this.state.heseUploadResult} isOpen={this.state.isDialogOpen} onClose={this.closeDialog} />
      </div>
    )
  }
}

function UploadWeeklyHesburgerEfficiencies({
  menuItems,
  file,
  week,
  year,
  handleYear,
  handleWeek,
  fileHandler,
  upload,
}) {
  return (
    <div className={css.heseUpload}>
      <div className={css.weekYearUpload}>
        <div className={css.inputWrapper}>
          <label>{i18n.t('admin.chainSettings.week')}</label>
          <Select id='selectWeek' value={week} onChange={handleWeek}>
            {menuItems}
          </Select>
        </div>
        <div className={css.inputWrapper}>
          <label>{i18n.t('admin.chainSettings.year')}</label>
          <TextField
            id='selectYear'
            value={year}
            type='number'
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]',
            }}
            onChange={handleYear}
          />
        </div>
      </div>
      <div className={css.fileUpload}>
        <Button variant='contained' component='label' color='primary'>
          <input type='file' accept={EXCEL_MIME_TYPE} hidden onChange={(e) => fileHandler(e)} />
          {i18n.t('admin.chainSettings.heseFile')}
        </Button>
        {file && <div className={css.fileName}>{file.name}</div>}
      </div>

      <div className={css.uploadButtonWrapper}>
        <Mutation mutation={uploadHesburgerEfficiencies}>
          {(onMutate) => (
            <Button
              disabled={!file}
              variant='contained'
              component='label'
              color='primary'
              onClick={() => upload(onMutate)}
            >
              {i18n.t('admin.chainSettings.heseSend')}
            </Button>
          )}
        </Mutation>
      </div>
    </div>
  )
}

function UploadMonthlyHesburgerEfficiencies({
  menuItems,
  file,
  month,
  year,
  handleYear,
  handleMonth,
  fileHandler,
  upload,
}) {
  return (
    <div className={css.heseUpload}>
      <div className={css.weekYearUpload}>
        <div className={css.inputWrapper}>
          <label>{i18n.t('admin.chainSettings.month')}</label>
          <Select id='selectMonth' value={month} onChange={handleMonth}>
            {menuItems}
          </Select>
        </div>
        <div className={css.inputWrapper}>
          <label>{i18n.t('admin.chainSettings.year')}</label>
          <TextField
            id='selectYear'
            value={year}
            type='number'
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]',
            }}
            onChange={handleYear}
          />
        </div>
      </div>
      <div className={css.fileUpload}>
        <Button variant='contained' component='label' color='primary'>
          <input type='file' accept={EXCEL_MIME_TYPE} hidden onChange={(e) => fileHandler(e)} />
          {i18n.t('admin.chainSettings.heseFile')}
        </Button>
        {file && <div className={css.fileName}>{file.name}</div>}
      </div>

      <div className={css.uploadButtonWrapper}>
        <Mutation mutation={uploadHesburgerEfficiencies}>
          {(onMutate) => (
            <Button
              disabled={!file}
              variant='contained'
              component='label'
              color='primary'
              onClick={() => upload(onMutate)}
            >
              {i18n.t('admin.chainSettings.heseSend')}
            </Button>
          )}
        </Mutation>
      </div>
    </div>
  )
}

export default ChainSettings
